module.exports = __webpack_public_path__ + "img/picture_02@2x.6df02d58.png";